/**
 * useGreeting(user) — trilingual, time-of-day greeting keyed off the user's language preference.
 * Owner/Head screens: pass user directly.
 * Field screens: pass user (defaults to English if language missing).
 */
export function useGreeting(user, nameOverride) {
    const lang = (user?.language || "en").toLowerCase();
    const name = nameOverride || (user?.name || "").split(" ")[0] || "";
    const hour = new Date().toLocaleTimeString("en-IN", { hour: "2-digit", hour12: false, timeZone: "Asia/Kolkata" });
    const h = parseInt(hour, 10);

    let bucket;
    if (h >= 4 && h < 12) bucket = "morning";
    else if (h >= 12 && h < 17) bucket = "afternoon";
    else if (h >= 17 && h < 21) bucket = "evening";
    else bucket = "night";

    const DICT = {
        morning:   { en: "Good morning",  hi: "सुप्रभात",    bn: "শুভ সকাল" },
        afternoon: { en: "Good afternoon", hi: "नमस्ते",     bn: "শুভ দুপুর" },
        evening:   { en: "Good evening",   hi: "शुभ संध्या", bn: "শুভ সন্ধ্যা" },
        night:     { en: "Good night",     hi: "शुभ रात्रि",  bn: "শুভ রাত্রি" },
    };
    const g = (DICT[bucket] || DICT.morning)[lang] || DICT[bucket].en;
    return { greeting: g, name, phrase: name ? `${g}, ${name}` : g, lang };
}

export default useGreeting;
